var parts = ['root', 'tab', 'tablist', 'tabpanel', 'tabpanels', 'indicator'];
var baseStyleRoot = function baseStyleRoot(props) {
  var orientation = props.orientation;
  return {
    display: orientation === 'vertical' ? 'flex' : 'block'
  };
};
var baseStyleTab = function baseStyleTab(props) {
  var isFitted = props.isFitted;
  return {
    flex: isFitted ? 1 : undefined,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  };
};
var baseStyleTablist = function baseStyleTablist(props) {
  var _props$align = props.align,
    align = _props$align === void 0 ? 'start' : _props$align,
    orientation = props.orientation;
  var alignments = {
    end: 'flex-end',
    center: 'center',
    start: 'flex-start'
  };
  return {
    justifyContent: alignments[align],
    flexDirection: orientation === 'vertical' ? 'column' : 'row'
  };
};
var baseStyleTabpanel = {
  p: 4
};
var baseStyle = function baseStyle(props) {
  return {
    root: baseStyleRoot(props),
    tab: baseStyleTab(props),
    tablist: baseStyleTablist(props),
    tabpanel: baseStyleTabpanel
  };
};
var sizes = {
  xs: {
    tab: {
      py: 2.5,
      px: 2,
      fontSize: 'sm'
    }
  },
  sm: {
    tab: {
      fontSize: 'md',
      py: 2,
      px: 2
    }
  },
  md: {
    tab: {
      fontSize: 'lg',
      py: 3,
      px: 4
    }
  }
};
function variantFullyEnclosed(props) {
  var c = props.colorScheme,
    isFitted = props.isFitted,
    align = props.align;
  var hasNoTopLeftBorder = isFitted || align === 'start' || align === undefined;
  var hasNoTopRightBorder = isFitted || align === 'end';
  return {
    tab: {
      color: 'gray.400',
      fontWeight: 600,
      noOfLines: 1,
      borderTopRadius: 'base',
      border: '1px solid',
      borderColor: 'transparent',
      mb: '-1px',
      _selected: {
        color: "".concat(c, ".400"),
        bg: 'white',
        borderColor: "".concat(c, ".400"),
        borderBottom: 'none'
      }
    },
    tablist: {
      px: 0
    },
    tabpanel: {
      bg: 'white',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: "".concat(c, ".400"),
      /* Remove the round border on the first panel to prevent a gap in the border */
      '&[id$="tabpanel-0"]': {
        borderTopLeftRadius: hasNoTopLeftBorder && 0
      },
      /* Remove the round border on the last panel to prevent a gap */
      '&:last-of-type': {
        borderTopRightRadius: hasNoTopRightBorder && 0
      },
      /* Similar to shadow: 'sm' but with a negative spread radius.
      Necessary so it doesn't spill into the tablist */
      shadow: '0 2px 2px -2px rgba(63,62,75,0.20), 0 2px 3px -3px rgba(63,62,75,0.10)'
    }
  };
}
function variantEnclosed(props) {
  var c = props.colorScheme;
  return {
    tab: {
      color: 'gray.400',
      borderTopRadius: 'base',
      border: '1px solid',
      borderColor: 'transparent',
      mb: '-1px',
      noOfLines: 1,
      _selected: {
        color: "".concat(c, ".500"),
        bg: 'white',
        borderColor: "".concat(c, ".400"),
        borderBottomColor: 'white'
      }
    },
    tablist: {
      px: 4,
      borderBottom: '1px solid',
      borderColor: "".concat(c, ".400")
    },
    tabpanel: {
      bg: 'white'
    }
  };
}
function variantUnstyled() {
  return {};
}
var variants = {
  fullyEnclosed: variantFullyEnclosed,
  enclosed: variantEnclosed,
  unstyled: variantUnstyled
};
var defaultProps = {
  size: 'md',
  variant: 'fullyEnclosed',
  colorScheme: 'blue',
  align: 'start'
};
var Tabs = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: defaultProps
};
export { Tabs as default };